module.exports={
	"Form": "ContactEditManifest",
	"Scope": "Contact-Edit",
	"Descriptors":
	{
		"ContactDetails.Title":
		{
			"Name": "Title",
			"Hash": "Contact-Edit-Title",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Contact-Edit-Identity",
				"Group": "Contact-Edit-Identity"
			}
		},
		"ContactDetails.NameFirst":
		{
			"Name": "Name First",
			"Hash": "Contact-Edit-NameFirst",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-Edit-Details",
				"Group": "Contact-Edit-Details"
			}
		},
		"ContactDetails.NameLast":
		{
			"Name": "Name Last",
			"Hash": "Contact-Edit-NameLast",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-Edit-Details",
				"Group": "Contact-Edit-Details"
			}
		},
		"ContactDetails.NameFull":
		{
			"Name": "Name Full",
			"Hash": "Contact-Edit-NameFull",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-Edit-Details",
				"Group": "Contact-Edit-Details"
			}
		},
		"ContactDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Contact-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Contact-Edit-Details",
				"Group": "Contact-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"ContactDetails.Email":
		{
			"Name": "Email",
			"Hash": "Contact-Edit-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 6,
				"Section": "Contact-Edit-Contact",
				"Group": "Contact-Edit-Contact"
			}
		},
		"ContactDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "Contact-Edit-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Contact-Edit-Contact",
				"Group": "Contact-Edit-Contact"
			}
		},
		"ContactDetails.IDContact":
		{
			"Name": "IDContact",
			"Hash": "Contact-Edit-IDContact",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Contact-Edit-DataAudit",
				"Group": "Contact-Edit-DataAudit"
			}
		},
		"ContactDetails.GUIDContact":
		{
			"Name": "GUIDContact",
			"Hash": "Contact-Edit-GUIDContact",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Contact-Edit-DataAudit",
				"Group": "Contact-Edit-DataAudit"
			}
		},
		"ContactDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Contact-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Contact-Edit-DataAudit",
				"Group": "Contact-Edit-DataAudit"
			}
		},
		"ContactDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Contact-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Contact-Edit-DataAudit",
				"Group": "Contact-Edit-DataAudit"
			}
		},
		"ContactDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Contact-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Contact-Edit-DataAudit",
				"Group": "Contact-Edit-DataAudit"
			}
		},
		"ContactDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Contact-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Contact-Edit-DataAudit",
				"Group": "Contact-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Contact-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Contact-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Contact-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Contact-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "Contact-Edit-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "Contact-Edit-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Contact-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Contact-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
